export default {
  // Navbar
  'nav.features': 'Features',
  'nav.technology': 'Technology',
  'nav.useCases': 'Use Cases',
  'nav.demo': 'Demo',
  'nav.contact': 'Contact',
  'nav.docs': 'Docs',

  // Hero
  'hero.title': 'Your Age, Verified.',
  'hero.title2': 'Your Identity, Protected.',
  'hero.subtitle': 'ZK Face is a Zero-Knowledge based authentication technology that verifies "over 19 years old" without exposing your face.',
  'hero.cta.demo': 'Try Full Demo',
  'hero.cta.contact': 'Contact Partnership',
  'hero.ageGuess.title': 'How old do I look?',
  'hero.ageGuess.upload': 'Upload Photo',
  'hero.ageGuess.badge': 'Photos are not sent to the server',
  'hero.ageGuess.result': 'AI Estimated Age',
  'hero.ageGuess.confidence': 'Confidence Interval',
  'hero.ageGuess.privacy1': 'No Storage',
  'hero.ageGuess.privacy2': '100% Local ML',
  'hero.ageGuess.privacy3': 'No Identity Exposure',

  // Problem
  'problem.title': 'The Internet Keeps Asking for Your Identity.',
  'problem.title2': 'But Why Should You Give It Away?',
  'problem.description': 'Most online services still require high-risk personal information such as social security numbers, original face images, and dates of birth. Users are anxious, and service providers bear excessive responsibility.',
  'problem.point1.title': 'Personal Data Breach Risk',
  'problem.point1.desc': 'Sensitive information stored on centralized servers is always exposed to hacking risks.',
  'problem.point2.title': 'Central Server Storage',
  'problem.point2.desc': 'Face and identity information is permanently stored on third-party servers.',
  'problem.point3.title': 'Global Regulation Strengthening',
  'problem.point3.desc': 'Privacy regulations such as GDPR and CCPA are becoming increasingly strict.',
  'problem.point4.title': 'Web3 Inefficiency',
  'problem.point4.desc': 'Legacy KYC systems are not suitable for decentralized environments.',

  // Solution
  'solution.title': 'Prove Your Age. Reveal Nothing.',
  'solution.description': 'ZK Face operates based on three core principles.',
  'solution.card1.title': 'Zero-Knowledge Proof',
  'solution.card1.desc': 'Prove your age without revealing identity information.',
  'solution.card2.title': 'Local Machine Learning',
  'solution.card2.desc': 'All facial analysis is performed only on the user\'s device.',
  'solution.card3.title': 'Data-Free Certification',
  'solution.card3.desc': 'The server does not store any photos and only verifies the Proof.',

  // How It Works
  'howItWorks.title': 'How It Works',
  'howItWorks.subtitle': 'This entire process is designed so that the server and facial information never intersect.',
  'howItWorks.step1.title': 'Capture Face',
  'howItWorks.step1.desc': 'The image is prepared on the user\'s local device.',
  'howItWorks.step2.title': 'ML Model Analyzes Features',
  'howItWorks.step2.desc': 'Only feature values are generated without storing the face.',
  'howItWorks.step3.title': 'Generate ZK-Proof',
  'howItWorks.step3.desc': 'Only the proof "this user is over 19 years old" is extracted inside the device.',
  'howItWorks.step4.title': 'Server Verification',
  'howItWorks.step4.desc': 'Only the Proof is transmitted, and the original information is not sent to the server.',

  // Use Cases
  'useCases.title': 'Use Cases',
  'useCases.subtitle': 'ZK Face can be utilized in various industries.',
  'useCases.case1.title': 'Adult Verification for Web/Apps',
  'useCases.case1.desc': 'Safely handle adult verification on websites and apps.',
  'useCases.case2.title': 'Web3 Wallet Login + Age Gate',
  'useCases.case2.desc': 'Age verification system integrated with decentralized wallets.',
  'useCases.case3.title': 'Streaming·Gaming Age Control',
  'useCases.case3.desc': 'Age restriction features for streaming and gaming platforms.',
  'useCases.case4.title': 'Offline Kiosk Verification',
  'useCases.case4.desc': 'Safe authentication is possible even on offline kiosks.',
  'useCases.case5.title': 'Government Light-KYC Services',
  'useCases.case5.desc': 'Lightweight identity verification solution for government services.',
  'useCases.badge1': 'No Face Storage',
  'useCases.badge2': 'ZKP Verified',

  // Contact
  'contact.title': "Let's Build a Privacy-First Future Together.",
  'contact.subtitle': 'Feel free to contact us if you have any partnership inquiries or technical questions.',
  'contact.form.name': 'Name',
  'contact.form.email': 'Email',
  'contact.form.company': 'Company',
  'contact.form.message': 'Message',
  'contact.form.submit': 'Send Message',
  'contact.form.submitting': 'Sending...',
  'contact.form.success': 'Your message has been sent successfully!',
  'contact.form.error': 'An error occurred while sending. Please try again.',
  'contact.cta.contact': 'Contact Us',
  'contact.cta.deck': 'Download Partnership Deck',

  // Footer
  'footer.description': 'Protecting privacy with Zero-Knowledge based facial authentication technology.',
  'footer.product': 'Product',
  'footer.product.features': 'Features',
  'footer.product.technology': 'Technology',
  'footer.product.useCases': 'Use Cases',
  'footer.product.demo': 'Demo',
  'footer.resources': 'Resources',
  'footer.resources.docs': 'Documentation',
  'footer.resources.api': 'API',
  'footer.resources.sdk': 'SDK',
  'footer.resources.blog': 'Blog',
  'footer.company': 'Company',
  'footer.company.about': 'About',
  'footer.company.careers': 'Careers',
  'footer.company.press': 'Press Kit',
  'footer.company.contact': 'Contact',
  'footer.legal': 'Legal',
  'footer.legal.privacy': 'Privacy Policy',
  'footer.legal.terms': 'Terms of Service',
  'footer.legal.security': 'Security',
  'footer.copyright': '© 2025 ZK Face. All rights reserved.',
  'footer.poweredBy': 'Website Builder',
};
